import React, {Component} from "react";
import PropTypes from "prop-types";
import GemForm from "../../site/gem/components/GemForm";

class LinksContainer extends Component {

  render() {
    let width = '3.5rem';
    if (this.props.width) {
      width = this.props.width;
    }
    return <GemForm>
      <div className="w-full max-w-5xl bg-white/5 backdrop-blur border border-white/10 shadow-2xl rounded-2xl p-8">

        <header className="flex items-center gap-4 mb-6">
          <div className={'h-14 rounded-xl flex items-center justify-center font-bold text-black text-xl shadow-xl bg-gradient-to-br from-kiwiAcc to-green-500 p-2'} style={{ width: width }}>
            {this.props.mainTagTitle}
          </div>
          <div>
            <h1 className="text-green-400 text-xl font-semibold">{this.props.title}</h1>
            <p className="text-gray-200 opacity-90">{this.props.subtitle}</p>
          </div>
        </header>

        <nav className="grid grid-cols-1 sm:grid-cols-2 gap-6" aria-label="Kachel Navigation">
          {this.props.children}
        </nav>
        <footer className="text-right mt-6 opacity-80 text-sm">© 2026 <span id="year"></span> peer.kiwi</footer>
      </div>
    </GemForm>
  }
}

LinksContainer.propTypes = {
  width: PropTypes.string, mainTagTitle: PropTypes.string, title: PropTypes.string, subtitle: PropTypes.string
}
export default LinksContainer;
